import fetch,{postFrom} from '../utils/fetch';

export function houseInfoList(params) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/list',
    params
  })
}

export function getCondition() {
  return fetch({
    method: 'GET',
    url: 'houseInfo/condition'
  })
}

// 根据合作类型获取项目
export function projectByCooperationMode(projectCooperationModel) {
  return fetch({
    method: 'GET',
    url: 'projectBasics/projectByCooperationMode',
    params:{
      projectCooperationModel
    }
  })
}

// 项目、楼栋、楼层联动信息
export function buildInfo(projectCityCode) {
  return fetch({
    method: 'GET',
    url: 'projectBasics/buildInfo',
    params:{
      projectCityCode
    }
  })
}

// 批量上下架  houseInfo/batchAboveOrUnder
export function batchAboveOrUnder(data) {
  return postFrom('houseInfo/batchAboveOrUnder',data)
}

// 锁定解锁房间 houseInfo/lockStock
export function lockStock(data) {
  return postFrom('houseInfo/lockStock',data)
}


// 删除房源
export function deleteStock(data) {
  return postFrom('houseInfo/delete',data)
}

// 根据项目获取房型
export function getHouseType(projectFid) {
  return fetch({
    method: 'GET',
    url: 'housetype/forCondition',
    params:{
      projectFid
    }
  })
}

// 获取分租子库存 houseInfo/subList
export function getSubList(stockFid) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/subList',
    params:{
      stockFid
    }
  })
}

// /houseInfo/showOrHideHouse

export function showOrHideHouse(data) {
  return postFrom('houseInfo/showOrHideHouse',data)
}

// 添加房源下拉框数据获取 houseInfo/toAddHouse

export function getSelectData() {
  return fetch({
    method: 'GET',
    url: 'houseInfo/toAddHouse'

  })
}

// 添加房源

export function addStock(data) {
  return fetch({
    method: 'POST',
    url: 'houseInfo/addHouse',
    data
  })
}

// 根据项目获取最大可签约时间
export function getMaxsigndate(projectFid) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/getMaxsigndate',
    params:{
      projectFid
    }
  })
}
// 修改房源页面查询
export function toEditHouse(stockFid) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/toEditHouse',
    params:{
      stockFid
    }
  })
}

// 修改房源
export function updateHouse(data) {
  return fetch({
    method: 'POST',
    url: 'houseInfo/updateHouse',
    data
  })
}

// 修改删除子库存
export function deleteSubRoomBed(data) {
  return postFrom('houseInfo/deleteSubRoomBed',data)
}

// 查询空置待租库存列表
export function getVacancyForRentList(params) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/getVacancyForRentList',
    params
  })
}

// 工作台待租库存数量
export function getForRentNum(params) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/getForRentNum',
    params
  })
}

// 工作台保存待租库存跟进记录
export function saveForRentFollow(params) {
  return fetch({
    method:'POST',
    url:'houseInfo/saveForRentFollow',
    data:params
  })
}

// 工作台工作台查询待租库存跟进列表
export function getForRentFollowList(params) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/getForRentFollowList',
    params
  })
}

// 获取预订单号
export function getOrderFid(params) {
  return fetch({
    method: 'GET',
    url: 'reservation/order/stock',
    params,
  })
}

// 修改房源状态
export function updateHouseStatus(data) {
  return fetch({
    method: 'POST',
    url: 'houseInfo/updateHouse',
    data
  })
}
